var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightBluePattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 1143,
    viewBox: "0 0 120 1143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_853_5950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 1186
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 1143,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_853_5950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.206 121.205H90.1543V151.256H120.206V121.205Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1025 181.308H90.1538V151.256H60.1025V181.308Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1543 211.359H120.206V181.308H90.1543V211.359Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0518 211.359H60.103V181.308H30.0518V211.359Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.103 121.205H30.0518V151.256H60.103V121.205Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1538 61.1025H60.1025V91.1538H90.1538V61.1025Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.206 301.513H90.1543V331.564H120.206V301.513Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1025 361.615H90.1538V331.564H60.1025V361.615Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1543 391.667H120.206V361.615H90.1543V391.667Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0518 391.667H60.103V361.615H30.0518V391.667Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.103 301.513H30.0518V331.564H60.103V301.513Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1538 241.41H60.1025V271.462H90.1538V241.41Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.206 481.821H90.1543V511.872H120.206V481.821Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1538 511.872H60.1025V541.923H90.1538V511.872Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.206 541.923H90.1543V571.974H120.206V541.923Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.103 541.923H30.0518V571.974H60.103V541.923Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.103 481.821H30.0518V511.872H60.103V481.821Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1538 421.718H60.1025V451.769H90.1538V421.718Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 61.1027H30.0513V31.0514H0V61.1027Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 121.205H30.0513V91.1539H0V121.205Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 181.308H30.0513V151.256H0V181.308Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 241.41H30.0513V211.359H0V241.41Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 301.513H30.0513V271.462H0V301.513Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 361.615H30.0513V331.564H0V361.615Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 421.718H30.0513V391.667H0V421.718Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 481.821H30.0513V451.769H0V481.821Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 541.923H30.0513V511.872H0V541.923Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 602.026H30.0513V571.974H0V602.026Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 662.128H30.0513V632.077H0V662.128Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 722.231H30.0513V692.179H0V722.231Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 782.333H30.0513V752.282H0V782.333Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 842.436H30.0513V812.385H0V842.436Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 902.538H30.0513V872.487H0V902.538Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 962.641H30.0513V932.59H0V962.641Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1543 632.077H120.206V602.026H90.1543V632.077Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1025 662.128H90.1538V632.077H60.1025V662.128Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1543 692.18H120.206V662.128H90.1543V692.18Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0518 692.18H60.103V662.128H30.0518V692.18Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.103 602.026H30.0518V632.077H60.103V602.026Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.206 782.333H90.1543V812.385H120.206V782.333Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1025 842.436H90.1538V812.385H60.1025V842.436Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1543 872.487H120.206V842.436H90.1543V872.487Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0518 872.487H60.103V842.436H30.0518V872.487Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.103 782.333H30.0518V812.385H60.103V782.333Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1538 722.231H60.1025V752.282H90.1538V722.231Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1538 902.538H60.1025V932.59H90.1538V902.538Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1142.95H30.0513V1112.9H0V1142.95Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1025 1112.9H90.1538V1082.85H60.1025V1112.9Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1022.74H30.0513V992.693H0V1022.74Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1082.85H30.0513V1052.79H0V1082.85Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.206 962.641H90.1543V992.692H120.206V962.641Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1025 1022.74H90.1538V992.692H60.1025V1022.74Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1543 1052.79H120.206V1022.74H90.1543V1052.79Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0518 1052.79H60.103V1022.74H30.0518V1052.79Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.103 962.641H30.0518V992.692H60.103V962.641Z",
    fill: "#17D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1543 0.999939V31.0512H60.103V0.999939H30.0518V31.0512V61.1025V91.1538V121.205H60.103V151.256H90.1543V121.205H120.206V91.1538H150.257V61.1025H120.206V31.0512V0.999939H90.1543ZM60.103 61.1025H90.1543V91.1538H60.103V61.1025Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0518 181.308H60.103V151.256H30.0518V181.308Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.103 241.41H90.1543V271.462H60.103V241.41ZM90.1543 301.513H120.206V271.462H150.257V241.41H120.206V211.359H90.1543V181.308H60.103V211.359H30.0518V241.41V271.462V301.513H60.103V331.564H90.1543V301.513Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0518 361.615H60.103V331.564H30.0518V361.615Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.257 151.256H180.308V181.308H150.257V151.256ZM180.308 211.359H210.359V181.308H240.411V151.256H210.359V121.205H180.308V91.1539H150.257V121.205H120.206V151.256H90.1543V181.308H120.206V211.359H150.257V241.41H180.308V211.359Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.103 421.718H90.1543V451.769H60.103V421.718ZM90.1543 481.821H120.206V451.769H150.257V421.718H120.206V391.667H90.1543V361.615H60.103V391.667H30.0518V421.718V451.769V481.821H60.103V511.872H90.1543V481.821Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0518 541.923H60.103V511.872H30.0518V541.923Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.257 331.564H180.308V361.615H150.257V331.564ZM180.308 391.667H210.359V361.615H240.411V331.564H210.359V301.513H180.308V271.462H150.257V301.513H120.206V331.564H90.1543V361.615H120.206V391.667H150.257V421.718H180.308V391.667Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1543 602.026H120.206V571.974H90.1543V541.923H60.103V571.974H30.0518V602.026H60.103V632.077H90.1543V602.026Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0518 662.128H60.103V632.077H30.0518V662.128Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.103 722.231H90.1543V752.282H60.103V722.231ZM90.1543 782.333H120.206V752.282H150.257V722.231H120.206V692.179H90.1543V662.128H60.103V692.179H30.0518V722.231V752.282V782.333H60.103V812.385H90.1543V782.333Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0518 842.436H60.103V812.385H30.0518V842.436Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.257 632.077H180.308V662.128H150.257V632.077ZM150.257 511.872H180.308V541.923H150.257V511.872ZM180.308 692.179H210.359V662.128H240.411V632.077H210.359V602.026H180.308V571.974H210.359V541.923H240.411V511.872H210.359V481.821H180.308V451.769H150.257V481.821H120.206V511.872H90.1543V541.923H120.206V571.974H150.257V602.026H120.206V632.077H90.1543V662.128H120.206V692.179H150.257V722.231H180.308V692.179Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.257 812.385H180.308V842.436H150.257V812.385ZM180.308 872.487H210.359V842.436H240.411V812.385H210.359V782.333H180.308V752.282H150.257V782.333H120.206V812.385H90.1543V842.436H120.206V872.487H150.257V902.538H180.308V872.487Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.103 1022.74V1052.79H30.0518V1082.85V1112.9V1142.95V1173H60.103V1142.95H90.1543V1173H120.206V1142.95V1112.9H150.257V1082.85H120.206V1052.79H90.1543V1022.74H60.103ZM60.103 1082.85H90.1543V1112.9H60.103V1082.85Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.103 902.539H90.1543V932.59H60.103V902.539ZM90.1543 962.641H120.206V932.59H150.257V902.539H120.206V872.487H90.1543V842.436H60.103V872.487H30.0518V902.539V932.59V962.641H60.103V992.692H90.1543V962.641Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0518 1022.74H60.103V992.692H30.0518V1022.74Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.257 992.692H180.308V1022.74H150.257V992.692ZM210.359 992.692V962.641H180.308V932.59H150.257V962.641H120.206V992.692H90.1543V1022.74H120.206V1052.79H150.257V1082.85H180.308V1052.79H210.359V1022.74H240.411V992.692H210.359Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.103 1022.74V1052.79H30.0518V1082.85V1112.9V1142.95V1173H60.103V1142.95H90.1543V1173H120.206V1142.95V1112.9H150.257V1082.85H120.206V1052.79H90.1543V1022.74H60.103ZM60.103 1082.85H90.1543V1112.9H60.103V1082.85Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.103 902.539H90.1543V932.59H60.103V902.539ZM90.1543 962.641H120.206V932.59H150.257V902.539H120.206V872.487H90.1543V842.436H60.103V872.487H30.0518V902.539V932.59V962.641H60.103V992.692H90.1543V962.641Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0518 1022.74H60.103V992.692H30.0518V1022.74Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.257 992.692H180.308V1022.74H150.257V992.692ZM210.359 992.692V962.641H180.308V932.59H150.257V962.641H120.206V992.692H90.1543V1022.74H120.206V1052.79H150.257V1082.85H180.308V1052.79H210.359V1022.74H240.411V992.692H210.359Z",
    fill: "#0D058F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBluePattern);
export default __webpack_public_path__ + "static/media/lightBluePattern.ce4aa18ab3c2dd4be5bfc204b21f8a9a.svg";
export { ForwardRef as ReactComponent };